import queryString from 'query-string';
import { hashHistory } from 'react-router';
import { isPluginMode } from "./isPluginMode";

/**
 * Returns the value for the requested name in the query string
 * @param  {String} name Query String Key
 * @return {String}      Query String Value
 */
export function queryParam(name) {
  if(isPluginMode()) {
    const query = queryString.parse(hashHistory.getCurrentLocation().search);
    return query[name];
  }
  const query = queryString.parse(window.location.search);
  return query[name];
}

/**
 * Query string wrapper
 * @param {Object} object
 * @return {String}
 */
export function toQueryString(object) {
  return queryString.stringify(object);
}
